import { Container, Row, Col, Button } from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./ViewPage.css";
import userMaleImg from "../Assets/m-user.png";
import userFemaleImg from "../Assets/f-user.png";
import React, { useState, useEffect } from "react";
import axios from "axios";

const ViewCustomer = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { user_id } = useParams();
  const navigate = useNavigate();
  // const customer = getCustomerById(id);
  const [customer, setCustomer] = useState({});
  const [userImg, setUserImg] = useState("");

  // console.log("cfgfgsdgdgd",user_id);
  useEffect(() => {
    axios.post(`${API_BASE_URL}user_detail.php`, { user_id: user_id })
      .then((response) => {
        if (response.data.head.code === 200) {
          setCustomer(response.data.body);
          if(response.data.body.gender=="Male") {
setUserImg(userMaleImg);
          } else {
setUserImg(userFemaleImg);
          }

          // setFilteredOrders(response.data.body);
          // console.log(response.data.body[0]);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomer([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomer([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  if (!customer) {
    return (
      <Container fluid className="outer-container my-4">
        <h2 className="text-center mb-3">User Detail</h2>
        <Row>
          <Col>
            <div className="not-found-box">Loading...</div>
          </Col>
        </Row>
      </Container>
    );
  }

  return (
    <Container fluid className="outer-container my-4">
      <h2 className="text-center mb-3">User Details</h2>

      <div className="customer-header d-flex justify-content-end align-items-center mb-3">
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <div className="customer-view-wrapper">
        <div className="customer-view-card">
          <div className="customer-photo-wrap">
            <img src={customer.image || userImg} alt={customer.name} className="customer-view-photo" />
          </div>

          <div className="customer-details-table-wrapper">
            <table className="customer-view-table" role="table" aria-label={`Details for ${customer.name}`}>
              <tbody>
                <tr>
                  <td className="field-cell">Full Name</td>
                  <td className="value-cell">{customer.name}</td>
                </tr>

                <tr>
                  <td className="field-cell">Gender</td>
                  <td className="value-cell">{customer.gender || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Date of Birth</td>
                  <td className="value-cell">{customer.date_of_birth || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Email</td>
                  <td className="value-cell">{customer.email}</td>
                </tr>

                <tr>
                  <td className="field-cell">Password</td>
                  <td className="value-cell">{customer.password}</td>
                </tr>

                <tr>
                  <td className="field-cell">Contact Number</td>
                  <td className="value-cell">{customer.mobile || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Address</td>
                  <td className="value-cell">{customer.address || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Blood Group</td>
                  <td className="value-cell">{customer.blood || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Aadhar Number</td>
                  <td className="value-cell">{customer.aadhar || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">PAN Card Number</td>
                  <td className="value-cell">{customer.pan_card || "-"}</td>
                </tr>

                {/* <tr>
                  <td className="field-cell">Educational Qualification</td>
                  <td className="value-cell">{customer.qualification || "-"}</td>
                </tr> */}

                <tr>
                  <td className="field-cell">Department</td>
                  <td className="value-cell">{customer.depart_name || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Designation</td>
                  <td className="value-cell">{customer.desig_name || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Staff Type</td>
                  <td className="value-cell">{customer.staff_type || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Date of Joining</td>
                  <td className="value-cell">{customer.date_of_join || "-"}</td>
                </tr>
{customer.desig_id !== "1" && (
  <>
                <tr>
                  <td className="field-cell">Total Leave(CL)</td>
                  <td className="value-cell">{customer.total_leave || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Taken Leave(CL)</td>
                  <td className="value-cell">{customer.taken_leave || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">Remaining Leave(CL)</td>
                  <td className="value-cell">{customer.remaining_leave || "-"}</td>
                </tr>

                <tr>
                  <td className="field-cell">LOP</td>
                  <td className="value-cell">{customer.lop || "-"}</td>
                </tr>
                </>
)}
                {customer.staff_type == "Aided" && customer.desig_id !== "1" && (
                  <>
                    <tr>
                      <td className="field-cell">Total Leave(ML)</td>
                      <td className="value-cell">{customer.total_leave_ml || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Taken Leave(ML)</td>
                      <td className="value-cell">{customer.taken_leave_ml || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Remaining Leave(ML)</td>
                      <td className="value-cell">{customer.remaining_leave_ml || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Total Leave(RL)</td>
                      <td className="value-cell">{customer.total_leave_rl || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Taken Leave(RL)</td>
                      <td className="value-cell">{customer.taken_leave_rl || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Remaining Leave(RL)</td>
                      <td className="value-cell">{customer.remaining_leave_rl || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Total Leave(EL)</td>
                      <td className="value-cell">{customer.total_leave_el || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Taken Leave(EL)</td>
                      <td className="value-cell">{customer.taken_leave_el || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Remaining Leave(EL)</td>
                      <td className="value-cell">{customer.remaining_leave_el || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Total Leave(UEL)</td>
                      <td className="value-cell">{customer.total_leave_uel || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Taken Leave(UEL)</td>
                      <td className="value-cell">{customer.taken_leave_uel || "-"}</td>
                    </tr>

                    <tr>
                      <td className="field-cell">Remaining Leave(UEL)</td>
                      <td className="value-cell">{customer.remaining_leave_uel || "-"}</td>
                    </tr>
                  </>
                )}
                {customer.staff_type == "Aided" && customer.gender == "Female" && customer.desig_id !== "1" && (
                  <tr>
                    <td className="field-cell">Maternity Leave</td>
                    <td className="value-cell">{customer.maternity_leave || "-"}</td>
                  </tr>
                )}
                {customer.desig_id !== "1" && (
                  <>
                <tr>
                  <td className="field-cell">Total OD Taken</td>
                  <td className="value-cell">{customer.od_count || "-"}</td>
                </tr>
                <tr>
                  <td className="field-cell">Permission(Per Month)</td>
                  <td className="value-cell">{customer.total_permission || "-"}</td>
                </tr>
                <tr>
                  <td className="field-cell">Taken Permission</td>
                  <td className="value-cell">{customer.taken_permission || "-"}</td>
                </tr>
                <tr>
                  <td className="field-cell">Remaining Permission</td>
                  <td className="value-cell">{customer.remaining_permission || "-"}</td>
                </tr>
                </>
                )}
                <tr>
                  <td className="field-cell">Basic Salary</td>
                  <td className="value-cell">{customer.basic_salary ? `₹${customer.basic_salary}` : "-"}</td>
                </tr>
                <tr>
                  <td className="field-cell">Biometric Code</td>
                  <td className="value-cell">{customer.biometric_code ? `${customer.biometric_code}` : "-"}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ViewCustomer;